define('commons/request-parser',['jquery', 'formatDateTime'], function($) {
    
    /**
     * Translates a serialized request (via jquery's 'serialize' function) into a human readable one.
     * @param fieldDescriptionMap : Map containing ids with some information. Id as keys, and their corresponding information as values. e.g. :
     *                     {'id' : {
     *                          'label' : 'Id', 
     *                          'defaultValue' : '-1', // optional, used for select most of the time
     *                          'values' : {'val' : 'Value', 'val2' : 'Value 2', ...} // optional, used for select most of the time
     *                          'dateFormat' : 'M d yy' // see format in jquery plugin formatDateTime,
     *                          'dynamicInputSelector' : 'input#group' // selector for particular inputs
     *                      },
     *                      
     *                      'myField2' : {...
     *                      }...
     *                     } 
     * @param aliasesForIds : Map containing all ajax loaded selects ids patterns (woah). These fields'll appear with the name of the parent field.
     */
    var RequestParser = function( fieldDescriptionMap, aliasesForIds ) {
        this.fieldDescriptionMap = fieldDescriptionMap;
        this.aliasesForIds = aliasesForIds;
    }
    
    /**
     * Split the request, group field values and build the human readable request.
     */
    RequestParser.prototype.parse = function( serializedRequest ){
        // [ 'id=4455566879', 'name=', 'site=', 'version=-1', ... ]
        var idWithValues = serializedRequest.split('&');

        // checks for aliases aka ajax selects
        this._filterAliases( idWithValues );

        // Groups values if an id is duplicated, e.g. 'groupId' : 'abc', 'groupId' : 'def' + filter not used attributes
        // {'id1' : ['ab0c514'], 'id2' : ['abcd', 'efgh'], ...}
        var idValuesMap = this._reduceValues( idWithValues );
        
        // Iterates and print
        var readableRequest = this._buildRequest( idValuesMap );

        return unescape(readableRequest);
    };
    
    RequestParser.prototype._reduceValues = function( idWithValues ){
        var idValuesMap = {};

        for (var i = 0, length = idWithValues.length; i < length; i++) {
            var idValSplited = idWithValues[i].split('=');
            var id = idValSplited[0];
            var val = unescape(decodeURIComponent(idValSplited[1]));
            
            // Keep only used fields : 
            // 'val' is set 
            // && id exists in the field list (we add some extra args in the request so we've to check this)
            //    or is an alias of a field (location contains up to 3 selects)
            if( !!val && ( fieldDesc = this.fieldDescriptionMap[id] ) ){
                var defaultVal = fieldDesc.defaultValue;
                // no default value, so we check the '-1' value (default in our <option>)
                if( typeof defaultVal === 'undefined' ){
                    if(val != '-1'){
                        idValuesMap[id] = idValuesMap[id] || [];
                        idValuesMap[id].push(val);
                    }
                }
                // if there's a default, val has to be different
                else if(val != defaultVal){
                    idValuesMap[id] = idValuesMap[id] || [];
                    idValuesMap[id].push(val);
                }
            } 
        };
        
        return idValuesMap;
    };
    
    RequestParser.prototype._buildRequest = function ( idValuesMap ){
        var readableRequest = '';
        
        // filtered values
        for (var id in idValuesMap) {

            // Check if there's a dynamic input first
            var displayValues = false;
            if (this.fieldDescriptionMap[id].dynamicInputSelector) {
                var formElement = $(this.fieldDescriptionMap[id].dynamicInputSelector);
                if (formElement.is("option")) {
                    displayValues = formElement.text();
                } else {
                    displayValues = formElement.val();
                }
            }
            // most of the time there'll be only one value in idValuesMap[id] 
            if(!displayValues){
                displayValues = $.map(idValuesMap[id], $.proxy(function(val){
                    var dateFormat = this.fieldDescriptionMap[id].dateFormat;
                    if(dateFormat){
                        return $.formatDateTime(dateFormat, new Date(unescape(val).replace(/\+/g, ' ')));
                    }
                    return this.fieldDescriptionMap[id].values ? this.fieldDescriptionMap[id].values[val] : val;
                },this)).join(', ');
            }
            
            readableRequest += '<div class="filter-field-description">' +
                                    '<span class="filter-description-label">' + this.fieldDescriptionMap[id].label + '</span>' + 
                                    $('<span class="filter-description-value"></span>').text(' : ' + displayValues).html() +
                               '</div>';
        }
        
        return readableRequest;
    };
    
    /**
     * If there's some aliases in the request e.g. "country=42&level_1=233..." where country and level_1 are 'location' aliases,
     * it builds a map as follow : 
     *      {
     *          'location' : {
     *              'country' : 42,
     *              'level_1' : 233
     *          },
     *          ...
     *      } 
     * It also removes aliases from the original idWithValues array.
     */
    RequestParser.prototype._filterAliases = function ( idWithValues ){
        for( var id in this.aliasesForIds ){
            // ["alias1", "alias2", /[abc]*/,...]
            var aliases = this.aliasesForIds[id];
            
            for (var i = 0, length = idWithValues.length; i < length; i++) {
                var idValSplited = idWithValues[i].split('=');
                var usedId = idValSplited[0];
                var val = idValSplited[1];
                if( typeof val !== 'undefined' && val !== null ){
                    for (var j = 0; j < aliases.length; j++) {
                        if( usedId.match(aliases[j]) ){
                            idWithValues[i] = id + '=' + $('select[name=\'' + usedId + '\'] option[value=\'' + val + '\']').html();
                        }
                    }
                }
            }
        }
    };
    
    return RequestParser;
});
